import Vue from 'vue'
import App from './App'
import { router } from './router/router'

import store from '@/store'
import './icons' // icon
import moment from 'moment'
import * as filters from './filters' // global filters
// 引入vant懒加载和样式
import Vant, { Lazyload, Toast, Dialog, Notify, Popup, Loading, Overlay } from 'vant'
import 'vant/lib/index.less'
// import examApi from '@/store'
import formValidate from '@/utils/formValidate'
import 'lib-flexible'
Vue.use(Lazyload)
Vue.use(Vant)
Vue.use(Dialog);
Vue.use(Popup);
Vue.use(Loading);
Vue.use(Overlay);


// store.dispatch('dict/getDicts').then(() => {
//   console.log('数据字典加载成功...')
// })
Vue.prototype.resetSetItem = function (key, newVal) {
  console.log(key, newVal,'key, newVal');
  
  if (key === 'modelTime') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent')
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal)
  }
}
// 时间转化
Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// // 定义字典全局方法
// Vue.prototype.dictList = function(code) {
//   return store.getters.dicts[code]
// }

// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'Cvg6bkUEqiCbfYxOX9UPxTdMrmdGLNBp'
})

Vue.prototype.formValidate = formValidate

Vue.config.productionTip = false
Vue.prototype.$toast = Toast
Vue.prototype.$dialog = Dialog
Vue.prototype.$loading = Loading
Vue.prototype.$overlay = Overlay
Vue.prototype.$notify = Notify
new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})
